import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { EnquiryProvider } from "./components/EnquiryContext";
import { Navbar } from "./components/Navbar";
import { StickyCTA } from "./components/StickyCTA";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import TourDetail from "./pages/TourDetail";
import LegalPage from "./pages/LegalPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App noise-overlay">
      <BrowserRouter>
        <EnquiryProvider>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tours/:slug" element={<TourDetail />} />
            <Route path="/legal/:doc" element={<LegalPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <StickyCTA />
        </EnquiryProvider>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
